// lib/client-log.ts
type Level = 'debug' | 'info' | 'warn' | 'error';

const LEVEL_ORDER: Record<Level, number> = {
  debug: 10,
  info: 20,
  warn: 30,
  error: 40,
};

const CURRENT =
  LEVEL_ORDER[
    (process.env.NEXT_PUBLIC_CLIENT_LOG_LEVEL as Level) ?? 'silent'
  ] ?? 100;

const enabled = (level: Level) => LEVEL_ORDER[level] >= CURRENT;

export const clog = {
  debug: (...args: any[]) => enabled('debug') && console.debug(...args),

  info: (...args: any[]) => enabled('info') && console.info(...args),

  warn: (...args: any[]) => enabled('warn') && console.warn(...args),

  error: (...args: any[]) => enabled('error') && console.error(...args),
};
